var map = {
	"./symbol_0.png": 53526,
	"./symbol_1.png": 66815,
	"./symbol_2.png": 29956,
	"./symbol_3.png": 83853,
	"./symbol_4.png": 78994,
	"./symbol_5.png": 93819,
	"./symbol_6.png": 15488,
	"./symbol_7.png": 93609,
	"./symbol_8.png": 64094,
	"./symbol_9.png": 16583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65793;